import React from 'react';

const VARIANTS = {
  // icon + wordmark, no tagline — for slim in-app headers
  compact: '/brand/logo-compact.png',
  // icon + wordmark + tagline — for splash/hero/auth screens
  full: '/brand/logo-full.png',
};

export const BrandLogo = ({ variant = 'compact', className = 'h-9 w-auto', ...props }) => (
  <img
    src={VARIANTS[variant]}
    alt="BookMyDriver — Drive Life, Not the Wheels!"
    className={className}
    data-testid={`brand-logo-${variant}`}
    {...props}
  />
);

export default BrandLogo;
